import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/sprite.svg'


const _hoisted_1 = _imports_0 + '#notFound'
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "search__header" }
const _hoisted_5 = {
  key: 0,
  class: "search__not-found"
}
const _hoisted_6 = {
  key: 1,
  class: "loader"
}
const _hoisted_7 = {
  key: 2,
  class: "search__list"
}

import Card from "@/components/Card.vue";
  import CartModal from "@/components/CartModal.vue";
  import Find from "@/components/Find.vue";
  import { IProduct } from "@/models/models";
  import { ref, watch } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Search',
  setup(__props) {

  const modelValue = ref<string>("" as string);

  let tm: any = null;

  const items = ref<Array<IProduct>>([] as Array<IProduct>);

  const isLoading = ref<boolean>(false as boolean);

  function onFind() {
    let localValue = modelValue.value;

    if (localValue.length > 3) {
      isLoading.value = true;
      if (tm) {
        clearTimeout(tm);
      }
      tm = setTimeout(async () => {
        fetch(`https://akshop.a-dev.xyz/api/v1/catalog/products?q=${localValue}`)
          .then((response) => response.json())
          .then((data) => {
            items.value = data.items;
            isLoading.value = false;
          });
      }, 600);
    } else {
      items.value = [];
    }
  }

  watch(
    () => modelValue.value,
    () => {
      onFind();
    }
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Find, {
            modelValue: modelValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        (items.value.length == 0 && !isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[1] || (_cache[1] = [
              _createElementVNode("svg", {
                class: "",
                width: "221",
                height: "217"
              }, [
                _createElementVNode("use", { "xlink:href": _hoisted_1 })
              ], -1),
              _createTextVNode(" Пока ничего не нашли ")
            ])))
          : _createCommentVNode("", true),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "loader-spinner" }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                return (_openBlock(), _createBlock(Card, { data: item }, null, 8, ["data"]))
              }), 256))
            ]))
      ])
    ]),
    _createVNode(CartModal)
  ], 64))
}
}

})